import React from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as formatter from 'helpers/Formatter';
import InvoiceList from './InvoiceList';
import ChangeSubscripion from './ChangeSubscripion';
import ConnectSetup from './ConnectSetup';

const blurOnLoad = value => {
  return value === undefined ? { filter: 'blur(2px)' } : {};
};

class CheckoutForm extends React.Component {
  state = { updateCard: false, error: '' };

  handleSubmit = ev => {
    ev.preventDefault();

    this.props.stripe.createToken().then(({ error, token }) => {
      if (token) {
        this.setState({ error: '', updateCard: false });
        this.props.updateBillingDetails({ token }).then(() => {
          this.props.getBillingDetails();
        });
      } else if (error) {
        this.setState({ error: error.message });
      }
    });
  };

  cardBrand = brand => {
    const brandLookup = {
      Visa: 'visa-d6c6e0a636f7373e06d5fb896ad49475.svg',
      Mastercard: 'mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg',
      'American Express': 'amex-edf6011de255d8a4c22904795c9d8770.svg',
    };

    if (!brandLookup[brand]) {
      return <h5>{brand}</h5>;
    } else {
      const brandUrl = `https://js.stripe.com/v3/fingerprinted/img/${brandLookup[brand]}`;
      return (
        <img
          src={brandUrl}
          alt="Credit Card Brand"
          style={{ height: '20px', marginRight: '5px' }}
        />
      );
    }
  };

  render() {
    const billingDetails = this.props.billingDetails || {};
    const paymentDetails = billingDetails.payment_details;

    return (
      <form onSubmit={this.handleSubmit} style={{ marginTop: '0px', marginBottom: '200px' }}>
        <div className="row" style={{ ...blurOnLoad(billingDetails.plan_price) }}>
          <ConnectSetup stripeConnected={billingDetails.stripe_connected} />
          <div className="col-xs-12" style={{ padding: 0 }}>
            <h4
              style={{
                textAlign: 'center',
                backgroundColor: colors.LIGHT_GRAY,
                padding: '5px',
              }}
            >
              Subscription Information
            </h4>
            <div
              className="row"
              style={{
                textAlign: 'left',
                fontSize: '14px',
                ...blurOnLoad(billingDetails.plan_price),
              }}
            >
              <div className="col-xs-6">
                <p>
                  <strong style={{ marginRight: '5px' }}>Current Plan: </strong>
                  <span>{formatter.formatMoney(billingDetails.plan_price)} per unit/month</span>
                </p>
              </div>
              <div className="col-xs-6">
                <p>
                  <strong style={{ marginRight: '5px' }}>Account Status: </strong>
                  <span>
                    {billingDetails.account_status}
                    {billingDetails.account_status === 'Trialing' && (
                      <span> ({billingDetails.trial_days_remaining} days remaining)</span>
                    )}
                  </span>
                </p>
              </div>
              <div className="col-xs-6">
                <p>
                  <strong style={{ marginRight: '5px' }}>Billed Units: </strong>
                  <span>{billingDetails.plan_quantity} units</span>
                </p>
              </div>
              <div className="col-xs-6">
                <p>
                  <strong style={{ marginRight: '5px' }}>Monthly Subtotal: </strong>
                  <span>{formatter.formatMoney(billingDetails.monthly_subtotal)}</span>
                </p>
              </div>
              <div className="col-xs-6">
                <p>
                  <strong style={{ marginRight: '5px' }}>Account Credits: </strong>
                  <span>{formatter.formatMoney(billingDetails.account_credits)}</span>
                </p>
              </div>
              <div className="col-xs-6">
                <ChangeSubscripion
                  updateBillingDetails={this.props.updateBillingDetails}
                  getBillingDetails={this.props.getBillingDetails}
                  canceled_at={billingDetails.canceled_at}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={{
            marginTop: '20px',
            ...blurOnLoad(billingDetails.plan_price),
          }}
        >
          <div className="col-xs-12" style={{ padding: 0 }}>
            <h4
              style={{
                textAlign: 'center',
                backgroundColor: colors.LIGHT_GRAY,
                padding: '5px',
              }}
            >
              Payment Information
            </h4>

            {(!paymentDetails || this.state.updateCard) && (
              <div className="row">
                {!paymentDetails && (
                  <p style={{ fontSize: '12px', color: AccentColor(), marginBottom: '15px' }}>
                    No payment information on file. Please update billing details.
                  </p>
                )}
                <div className="col-sm-5 col-sm-offset-3" style={{ marginTop: '8px' }}>
                  <CardElement />
                  <p style={{ fontSize: '12px', color: AccentColor() }}>{this.state.error}</p>
                </div>
                <div className="col-sm-2" style={{ paddingLeft: '0px' }}>
                  <div className="row">
                    {this.state.updateCard && (
                      <button
                        type="button"
                        className="link-button"
                        onClick={() => this.setState({ updateCard: false })}
                        style={{ textAlign: 'left' }}
                      >
                        <h5>Cancel</h5>
                      </button>
                    )}

                    <button type="button" className="link-button" onClick={this.handleSubmit}>
                      <h5>Update</h5>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {paymentDetails &&
              !this.state.updateCard && (
                <div className="row" style={blurOnLoad(billingDetails.plan_price)}>
                  <div className="col-sm-7">
                    <h5 style={{ float: 'left' }}>
                      {this.cardBrand(paymentDetails.brand)}
                      {`${paymentDetails.card_mask} ${paymentDetails.exp_month}/${paymentDetails.exp_year}`}
                    </h5>
                  </div>
                  <div className="col-sm-5">
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => this.setState({ updateCard: true })}
                      style={{ textAlign: 'left' }}
                    >
                      <h5>Edit Details</h5>
                    </button>
                  </div>
                </div>
              )}
          </div>
        </div>

        <div
          className="row"
          style={{ marginTop: '20px', ...blurOnLoad(billingDetails.plan_price) }}
        >
          <div className="col-xs-12" style={{ padding: 0 }}>
            <h4
              style={{
                textAlign: 'center',
                backgroundColor: colors.LIGHT_GRAY,
                padding: '5px',
              }}
            >
              Payment Receipts
            </h4>

            <div className="row">
              <div className="col-xs-12" style={{ padding: 0 }}>
                <InvoiceList invoices={billingDetails.invoices} />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);
